export enum ApplicationType {
  TYA = 'SFE_AMP_TYA',
}
